






























import { Vue, Component, Prop } from 'vue-property-decorator'
import MutationForm from '@/components/form/MutationForm.vue'

@Component({
  components: {
    MutationForm
  }
})
export default class LinkCreate extends Vue {
  @Prop({ type: String, required: true }) environmentId !: string
  @Prop({ type: String, default: 'primary' }) accentColor !: string
}
